module.exports = __webpack_public_path__ + "static/full-logo-a2e0b50b71f5ef1b4d3be4e1b61acc89.png";